import { publicRequest } from "../../../requestMeth";
import { createParametro_calculadoFailure, createParametro_calculadoStart, createParametro_calculadoSuccess, parametros_calculadosFailure, parametros_calculadosStart, parametros_calculadosSuccess } from "../../reducers/admin/calculatedParametersRedux";
import { updateFailure, updateStart, updateSuccess } from "../../reducers/admin/editCalculatedParameterRedux";



export const getCalculaterParameter = async (dispatch, token, selectedDeviceId) => {
  dispatch(parametros_calculadosStart());
  try {
    const endpoint = selectedDeviceId
      ? `/calculated_parameters?deviceId=${selectedDeviceId}`
      : `/calculated_parameters`;

    const res = await publicRequest.get(endpoint, {
      headers: { token: `Bearer ${token}` },
    });

    dispatch(parametros_calculadosSuccess(res.data));
  } catch (error) {
    dispatch(parametros_calculadosFailure());
  }
};



export const createParameterCalculated= async (dispatch, payload, token) => {
    dispatch(createParametro_calculadoStart());
    try {
      const res = await publicRequest.post(`/calculated_parameters`, payload,  {
          headers: { token: `Bearer ${token}` }
      });
        
      dispatch(createParametro_calculadoSuccess(res.data));
    } catch (error) {
        dispatch(createParametro_calculadoFailure());
        throw error;
    }
};

export const updateParameterCalculated = async (dispatch, id, payload, token) => {
  
    dispatch(updateStart());
    try {
        const res = await publicRequest.put(`/calculated_parameters/edit/${id}`, payload, {
            headers: { token: `Bearer ${token}` }
        });
        dispatch(updateSuccess(res.data));
    } catch (error) {
        dispatch(updateFailure());
        throw error;
    }
};
